import * as ActionTypes from '../constants/actiontypes/facturation';
import BillingUser from '../constants/models/billingUser';
import * as R from 'ramda';
import * as Loadings from '../constants/loadings/facturation';
import ProfileData from '../constants/models/profileData';
import Invoice from '../constants/models/invoice';

const FacturationReducer = (state = {
    userLoaded: false,
    isLoading: [],
    activationFailed: undefined,
    user: undefined,
    profiles: [],
    debitDirectUrl: undefined,
    profileInvoices: []
}, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_BILLING_USER_REQUEST:
            if (state.userLoaded !== true){
                state.isLoading.push(Loadings.FETCH_BILLING_USER);
            }
            return {
                ...state,
                userLoaded: state.userLoaded === true ? true: false
            };
        case ActionTypes.ACTIVATE_PROFILE_SUCCESS:
        case ActionTypes.FETCH_BILLING_USER_SUCCESS:
        case ActionTypes.SET_PROFILE_DEFAULT_SUCCESS:
            if (action.type === ActionTypes.ACTIVATE_PROFILE_SUCCESS){
                state.activationFailed = false;
            }
            state.isLoading = state.isLoading.filter(item => item !== Loadings.FETCH_BILLING_USER);
            return{
                ...state,
                user: new BillingUser(action.data),
                userLoaded: true
            };
        case ActionTypes.ACTIVATE_PROFILE_FAILURE:
            state.activationFailed = true;
            return{
                ...state
            };
        case ActionTypes.FETCH_BILLING_USER_FAILURE:
            state.isLoading = state.isLoading.filter(item => item !== Loadings.FETCH_BILLING_USER);
            return{
                ...state,
                userLoaded: false
            };
        case ActionTypes.FETCH_USER_PROFILES_REQUEST:
            state.isLoading.push(Loadings.FETCH_PROFILES);
            return {
                ...state
            };
        case ActionTypes.FETCH_USER_PROFILES_SUCCESS:
            state.isLoading = state.isLoading.filter(item => item !== Loadings.FETCH_PROFILES);
            if (action.data.length > 0){
                state.profiles = action.data.map(p => { return new ProfileData(p.id, p)});
            }
            return {
                ...state
            };
        case ActionTypes.FETCH_USER_PROFILES_FAILURE:
            state.isLoading = state.isLoading.filter(item => item !== Loadings.FETCH_PROFILES);
            return {
                ...state
            };
        case ActionTypes.ADD_DEBITDIRECT_START_SUCCESS:
            state.debitDirectUrl = action.data;
            return{
                ...state
            };
        case ActionTypes.ADD_PROFILE_SUCCESS:
            window.location = "/facturation/profile";
            return{
                ...state
            };
        case ActionTypes.ADD_PAYMENT_METHOD_SUCCESS:
        case ActionTypes.UPDATE_MEMBER_SUCCESS:
        case ActionTypes.DELETE_MEMBER_SUCCESS:
        case ActionTypes.ADD_MEMBER_PROFILE_SUCCESS:
        case ActionTypes.DELETE_PAYMENT_METHOD_SUCCESS:
        case ActionTypes.DELETE_PROFILE_PICTURE_SUCCESS:
        case ActionTypes.UDPATE_PROFILE_PICTURE_SUCCESS:
        case ActionTypes.UPDATE_PROFILE_DATA_SUCCESS:
            if(!R.isNil(action.data)){
                var retProfile = new ProfileData(action.data.id, action.data);
                var profileToUpdateIndex = state.profiles.findIndex(p => p.id === retProfile.id);
                if (profileToUpdateIndex !== -1){
                    state.profiles[profileToUpdateIndex] = retProfile;
                    state.profiles = JSON.parse(JSON.stringify(state.profiles));
                }
            }
            return{
                ...state
            };
        case ActionTypes.SET_DEFAULT_PAYMENT_SUCCESS:
            let selectedProfile = state.profiles.find(p => p.id === action.profile.id);
            if (!R.isNil(selectedProfile)){
                let paymentMethodId = selectedProfile.paymentMethods.findIndex(m => m.id === action.paymentMethod.id);
                if (paymentMethodId !== -1){
                    for(let i = 0; i< selectedProfile.paymentMethods.length; i++){
                        selectedProfile.paymentMethods[i].isDefault = false;
                    }
                    selectedProfile.paymentMethods[paymentMethodId].isDefault = true;
                }
            }
            return{
                ...state
            };
        case ActionTypes.FETCH_INVOICES_SUCCESS:
            if (action.data.length > 0){
                state.profileInvoices[action.profile.id] = action.data.map(inv => new Invoice(inv));
            }
            else{
                state.profileInvoices[action.profile.id] = [];
            }

        return{
            ...state
        };
        default:
            return state;
    }
}
export default FacturationReducer;